import { withNamespaces } from 'react-i18next';

import { BidRiskLevels, CyberSecurityStatuses } from '../../constants';

const CategoryList = ({
    activeCategoryId,
    data,
    onSelectCategory,
    t,
}) => {
    const risk = BidRiskLevels[data.risk];
    const totalChecks = data.categories.reduce((count, category) => count + category.checks.length, 0);

    return (
        <div className="cyber-nav">
            <div className="mb-3">
                <h5 className="mb-1">{t(data.title)}</h5>
                <p className="text-muted font-size-12 mb-0">
                    {t('{{categories}} categories · {{checks}} checks', {
                        categories: data.categories.length,
                        checks: totalChecks,
                    })}
                </p>
            </div>

            <div className="cyber-risk-banner mb-3">
                <div className="d-flex align-items-start gap-2">
                    <i className="ri-error-warning-fill text-warning" />
                    <div>
                        <div className="fw-medium">{t('{{risk}} Risk', { risk: t(risk.title) })}</div>
                        <p className="text-muted font-size-12 mb-0">{t(data.riskDescription)}</p>
                    </div>
                </div>
            </div>

            <div className="cyber-summary mb-3">
                <span>
                    <i className="ri-checkbox-circle-fill text-success" />
                    {data.summary.passed}
                    <small>{t('Passed')}</small>
                </span>
                <span>
                    <i className="ri-error-warning-fill text-warning" />
                    {data.summary.warnings}
                    <small>{t('Warnings')}</small>
                </span>
                <span>
                    <i className="ri-close-circle-fill text-danger" />
                    {data.summary.failed}
                    <small>{t('Failed')}</small>
                </span>
            </div>

            <button
                className={`cyber-nav-item ${activeCategoryId === 'overview' ? 'is-active' : ''}`}
                onClick={() => onSelectCategory('overview')}
                type="button"
            >
                <span className="cyber-nav-icon is-primary">
                    <i className="ri-shield-line" />
                </span>
                <span className="flex-grow-1 text-start">
                    <span className="d-block fw-medium">{t('Overview')}</span>
                    <span className="text-muted font-size-12">{t('All Findings')}</span>
                </span>
                <i className="ri-arrow-right-s-line text-muted" />
            </button>

            {data.categories.map((category) => {
                const status = CyberSecurityStatuses[category.status];
                const passedCount = category.checks.filter((check) => check.status === 'passed').length;

                return (
                    <button
                        className={`cyber-nav-item ${activeCategoryId === category.id ? 'is-active' : ''}`}
                        key={category.id}
                        onClick={() => onSelectCategory(category.id)}
                        type="button"
                    >
                        <span className={`cyber-nav-icon is-${category.iconColor}`}>
                            <i className={category.icon} />
                        </span>
                        <span className="flex-grow-1 text-start">
                            <span className="d-block fw-medium">{t(category.title)}</span>
                            <span className={`${status.className} font-size-12`}>
                                <i className={`${status.icon} align-middle me-1`} />
                                {t(status.title)}
                                <span className="text-muted">
                                    {` · ${passedCount} / ${category.checks.length} ${t('checks passed')}`}
                                </span>
                            </span>
                        </span>
                        <i className="ri-arrow-right-s-line text-muted" />
                    </button>
                );
            })}
        </div>
    );
};

export default withNamespaces()(CategoryList);
